import Repository from "./Repository";
import CompanyContact from "../types/CompanyContact";
import CompanyContactsResponse from "./response/CompanyContactsResponse";

const resource = "/companyContact";

export default {
  get(companyId: string) {
    return Repository.get<CompanyContactsResponse>(
      `${resource}/company/${companyId}`
    );
  },
  save(companyContact: CompanyContact) {
    if (companyContact.contactId) {
      return Repository.patch(`${resource}`, companyContact);
    } else {
      return Repository.post(`${resource}`, companyContact);
    }
  },

  delete(contactId: string) {
    return Repository.delete(`${resource}/${contactId}`);
  }
};
